module.exports = __webpack_public_path__ + "img/b3.a764985a.png";